import { render, staticRenderFns } from "./forfaitmodale.vue?vue&type=template&id=6a6b52e2&scoped=true"
import script from "./forfaitmodale.vue?vue&type=script&lang=js"
export * from "./forfaitmodale.vue?vue&type=script&lang=js"
import style0 from "./forfaitmodale.vue?vue&type=style&index=0&id=6a6b52e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6b52e2",
  null
  
)

export default component.exports